<template>
  <div class="topbg">
    <div class="topBox">
      <div class="maincontent">
        <el-row>
          <el-col :span="12" class="pt10" style="font-size: 32px">
            <div style="display: flex;align-items: center;">
            <!-- <span class="pding10 fb">武汉工商学院</span>| -->
            <el-image :src="logo" style="width: 280px;"/>
            <span
              class="pd10"
              style="font-size: 26px"
              >&nbsp;&nbsp;一站式服务大厅</span
            >
          </div>
            <div>
              <el-autocomplete
                class="inline-input"
                clearable
                v-model="state2"
                :fetch-suggestions="querySearch"
                placeholder="请输入内容"
                :trigger-on-focus="false"
                @select="handleSelect"
                style="width: 480px;margin-top: 10px;"
              ></el-autocomplete>
            </div>
          </el-col>
          <!--<el-col :offset="4" :span="4" class="tr">
           <el-input placeholder="请输入内容" v-model="keyWords" size="mini">
              <i slot="prefix" class="el-input__icon el-icon-search"></i>
            </el-input> 
          
          </el-col>-->
          <!-- <el-col :span="3">
           
          </el-col> -->
          <el-col :span="12" class="tr pt3 topright">
            <span
              v-if="userInfor"
              class="tr fb pt3 topright"
              style="font-size: 16px"
            >
              <span style="color: #fcff00">{{ userInfor.name }}</span
              >，欢迎您！</span
            >
            <a
              v-if="!userInfor"
              :href="
                this.ipURL + '/cas/login?service=' + this.baseURL + '/index'
              "
              >用户登录</a
            >
            <a v-if="userInfor" @click="loginOut()" style="cursor: pointer">
              <i class="el-icon-switch-button"></i>退出登录</a
            >
            <router-link to="/">
              <i class="el-icon-s-home"></i>大厅首页</router-link
            >
            <router-link to="/userCenter">
              <i class="el-icon-user"></i>个人中心</router-link
            >
          </el-col>
        </el-row>
      </div>
    </div>
    <!-- <div id="nav">s
      <router-link to="/">Home</router-link> |
      <router-link to="/about">About</router-link>
    </div>-->
    <div class="maincontent margintop200 pding20 boxShadow">
      <router-view :key="$route.fullPath" />
    </div>
    <div style="height: 44px"></div>
    <Foot style="position: fixed; bottom: 0; width: 100%" />
  </div>
</template>
<script>
import Foot from "@/components/Footer";
import { ipURL, baseURL } from "@/config/net.config.js";
import { mapGetters } from "vuex";
import { queryServiceName } from "@/api/serviceHome";
import { queryUserInfoByUserid } from "@/api/myHome";
import logo from "@/static/images/logo.png";

export default {
  name: "App",
  data() {
    return {
      logo:logo,
      userInfor: "",
      keyWords: "",
      ipURL: ipURL,
      baseURL: baseURL,
      restaurants: [],
      state2: "",
    };
  },
  computed: {
    ...mapGetters(["getStorage", "getUserInfo", "getUserId"]),
  },
  mounted: function () {
    console.log(this.isLogin());
    console.log("getUserInfogetUserInfo", this.getUserInfo);
    if (this.getUserInfo == null) {
      this.getUserInfoByUserid();
    } else {
      this.userInfor = this.getUserInfo;
    }
  },
  methods: {
    // 登录了就获取用户信息
    async getUserInfoByUserid() {
      console.log(this.getUserId);

      console.log(sessionStorage.getItem("userId"));
      if (sessionStorage.getItem("userId")) {
        const data = await queryUserInfoByUserid(
          sessionStorage.getItem("userId")
        );
        console.log(data);
        if (data.msgCode == 0) {
          this.userInfor = data.data;
          //  this.$store.commit('setUserInfo', JSON.stringify(data.data))
        }
      }
    },
    async querySearch(queryString, cb) {
      const data = await queryServiceName(queryString);
      let results = [];
      if (data.data == null) {
        results = [
          {
            value: "暂无数据",
            id: 0,
          },
        ];
        cb(results);
        return;
      }
      data.data.forEach((item) => {
        let r = {
          value: item.serviceName,
          id: item.id,
        };
        results.push(r);
      });
      // 调用 callback 返回建议列表的数据
      cb(results);
    },
    createFilter(queryString) {
      return (restaurant) => {
        return (
          restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) ===
          0
        );
      };
    },
    handleSelect(item) {
      this.$router.push("/serviceInfor?id=" + item.id);
    },
    isLogin() {
      if (this.getStorage) {
        return true;
      } else {
        return false;
      }
    },

    async loginOut() {
      console.log("登出");
      //      const casOpen = this.exitCas();
      // const portalOpen=  this.exitPortal();
      const loading = this.$loading({
        lock: true,
        text: "正在退出登录...",
        spinner: "el-icon-loading"
      });

      sessionStorage.removeItem("userId");
      sessionStorage.removeItem("token");
      sessionStorage.removeItem("userInfoToken");
      sessionStorage.removeItem("userInfo");
      sessionStorage.removeItem("xzztcToken");
      sessionStorage.clear(); //清除所有session值
      localStorage.clear();
      this.$store.commit("removeToken");
      this.$store.commit("removeInfo");
      this.$store.commit("removeUserId");
      loading.close();

      var userAgent = navigator.userAgent; // 取得浏览器的userAgent字符串
      console.log(userAgent);
      // var isOpera = userAgent.indexOf("Opera") > -1;
      // //判断是否Opera浏览器
      // if (isOpera) {
      //     return "Opera"
      // };
      //判断是否Firefox浏览器
      // if (userAgent.indexOf("Firefox") > -1) {
      //     return "FF";
      // }
      //判断是否chorme浏览器
      //判断是否Edge浏览器
      
      if (userAgent.indexOf("Edg") > -1) {

        const b1 = this.exitCas();
        const p = this.exitPortal();
        const b = this.exitCas();
        const c = this.exitPortal();
        await window.open(
          this.ipURL + "/cas/login?service=" + this.baseURL + "/index",
          "_self"
        );
        b1?.close();
        // a?.close();
        p?.close();
        b?.close();
        c?.close();
      }
      else  {
        const b1 = this.exitCas();
        const p = this.exitPortal();
        await window.open(
          this.ipURL + "/cas/login?service=" + this.baseURL + "/index",
          "_self"
        );
        b1?.close();
        p?.close();
      }
      //判断是否Safari浏览器
      // if (userAgent.indexOf("Safari") > -1) {
      //     return "Safari";
      // }
      //判断是否IE浏览器
      // if (userAgent.indexOf("compatible") > -1 && userAgent.indexOf("MSIE") > -1 && !isOpera) {
      //     return "IE";
      // }
      

      //  casOpen?.close();
      //     portalOpen?.close();

      // location.reload();
      //
    },
    exitCas() {
      const width = 600,
        height = 600;
      const left = window.innerWidth / 2 - width / 2;
      const top = window.innerHeight / 2 - height / 2;
      const url = this.ipURL + `/cas/logout`;
      return window.open(
        url,
        "", // Open window to server side
        `toolbar=no, location=no, directories=no, status=no, menubar=no,
          scrollbars=no, resizable=no, copyhistory=no, width=${width},
          height=${height}, top=${top}, left=${left}`
      );
    },
    exitPortal() {
      const width = 600,
        height = 600;
      const left = window.innerWidth / 2 - width / 2;
      const top = window.innerHeight / 2 - height / 2;
      const url = this.baseURL + `/portal/logout`;
      return window.open(
        url,
        "", // Open window to server side
        `toolbar=no, location=no, directories=no, status=no, menubar=no,
          scrollbars=no, resizable=no, copyhistory=no, width=${width},
          height=${height}, top=${top}, left=${left}`
      );
    },
  },
  components: { Foot }
};
</script>
<style>
.topbg {
  background: url(../assets/topbg2.png) center top no-repeat;
  background-size: 100% 450px;
}
.topBox {
  height: 350px;
  padding-top: 20px;
  color: #fff;
}

.topBox a {
  color: #fff;
  padding: 0 5px;
  font-size: 14px;
  font-weight: bold;
  text-decoration: none;
}

.el-autocomplete >>> .el-input__inner {
  height: 40px !important;
  margin-top: 10px;
}
.topright a {
  font-size: 15px;
}
</style>
